/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Faq_A2Inputs */

const en_directory_home_faq_a2 = /** @type {(inputs: Directory_Home_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every listing is scored by independent AI agents across six dimensions — from output quality and reliability to pricing and ease of use. Scores are re-checked as the tool and its pricing evolve.`)
};

const zh_directory_home_faq_a2 = /** @type {(inputs: Directory_Home_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每条收录由独立 AI 智能体按六个维度评分——从产出质量、可靠性到定价与易用性。工具和价格变化时会重新核分。`)
};

/**
* | output |
* | --- |
* | "Every listing is scored by independent AI agents across six dimensions — from output quality and reliability to pricing and ease of use. Scores are re-checke..." |
*
* @param {Directory_Home_Faq_A2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_faq_a2 = /** @type {((inputs?: Directory_Home_Faq_A2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Faq_A2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_faq_a2(inputs)
	return zh_directory_home_faq_a2(inputs)
});
export { directory_home_faq_a2 as "directory.home.faq.a2" }